/**
 * True while the user types in a field, so single-key shortcuts must not fire. Uses the
 * event's real target: inside a shadow root (the note editor) `event.target` is only the
 * shadow host.
 */
export function isTyping(event: Event): boolean {
  const target = event.composedPath()[0] ?? event.target;
  return (
    target instanceof HTMLElement &&
    (target.isContentEditable || ["INPUT", "TEXTAREA", "SELECT"].includes(target.tagName))
  );
}
